import { enumify } from '../utils/enumify'

export const CONNECTION_SOURCE_TYPES = enumify(['direct', 'single_word', 'descriptive'])
